module.exports = __webpack_public_path__ + "static/img/5_2_2.9fc00fdc.jpg";